import React from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import memoWithName from '@/hocs/memoWithName'
import useSvgColors from '@/hooks/useSvgColors'

const ReverseExclamationIcon = ({ color, onClick }) => {
  const {
    fill,
  } = useSvgColors(color)

  return (
    <svg onClick={onClick} width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill={fill} className="svgFill" clipRule="evenodd" d="M18.5 9C18.5 13.9706 14.4706 18 9.5 18C4.52944 18 0.5 13.9706 0.5 9C0.5 4.02944 4.52944 0 9.5 0C14.4706 0 18.5 4.02944 18.5 9ZM8.76845 11.1004H10.6663L10.9652 3H8.46952L8.76845 11.1004ZM8.76845 12.6391C8.52282 12.8942 8.4 13.2225 8.4 13.6242C8.4 14.0258 8.52282 14.3569 8.76845 14.6174C9.01872 14.8725 9.32923 15 9.7 15C10.0708 15 10.379 14.8725 10.6246 14.6174C10.8749 14.3569 11 14.0258 11 13.6242C11 13.2225 10.8749 12.8942 10.6246 12.6391C10.379 12.3786 10.0708 12.2483 9.7 12.2483C9.32923 12.2483 9.01872 12.3786 8.76845 12.6391Z" />
    </svg>
  )
}

ReverseExclamationIcon.propTypes = {
  color: pt.string,
  onClick: pt.func,
}

ReverseExclamationIcon.defaultProps = {
  color: null,
  onClick: noop,
}

export default memoWithName(ReverseExclamationIcon)
